/** Returns true when HTML/rich text has visible text content (not just empty tags). */
export function hasVisibleHtmlContent(html?: string | null): boolean {
  if (!html?.trim()) return false;
  const text = html
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  return text.length > 0;
}
